// extracted by mini-css-extract-plugin
module.exports = {"item":"MyFollows_item__3D7Mh","list":"MyFollows_list__3PTfn","info":"MyFollows_info__2cNWr"};